"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerTagDiscount = void 0;
var vue_1 = require("vue");
exports.PlayerTagDiscount = vue_1.default.component('PlayerTagDiscount', {
    props: {
        amount: {
            type: Number,
        },
    },
    methods: {
        getAmount: function () {
            return this.amount * -1;
        },
    },
    template: "\n    <div class=\"player-tag-discount\">\n      <div class=\"megacredits-container\">\n        <div class=\"megacredits\">{{ getAmount() }}</div>\n      </div>\n    </div>\n  ",
});
//# sourceMappingURL=PlayerTagDiscount.js.map